import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { EventManager } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material';

@Injectable()

export class SharedService {
    // Page Title
    private PageTitle: BehaviorSubject<string> = new BehaviorSubject('Redbook');
    get pageTitle$(): Observable<string> { return this.PageTitle.asObservable(); }
    set pageTitle(title: string) { this.PageTitle.next(title); }

    // Sending object for window resize.
    private windowResize: BehaviorSubject<Window> = new BehaviorSubject(window);
    get onResize$(): Observable<Window> { return this.windowResize.asObservable(); }

    // Dashboard page Loading
    private Loader: BehaviorSubject<boolean> = new BehaviorSubject(false);
    get loadingState$(): Observable<boolean> { return this.Loader.asObservable(); }
    set loadingState(boolValue) { this.Loader.next(boolValue); }

    // Search
    public displaySearchBox: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public searchString: BehaviorSubject<string> = new BehaviorSubject(null);

    // Page Controls dashboard
    private PageControls: BehaviorSubject<ActionButtons[]> = new BehaviorSubject(null);
    get pageControls$(): Observable<ActionButtons[]> { return this.PageControls.asObservable(); }
    set pageControls(actionBtns: ActionButtons[]) { this.PageControls.next(actionBtns); }

    // Routes pointer dont use as history.
    private previousUrl: string = undefined;
    private currentUrl: string = undefined;
    get getPreviousUrl() { return this.previousUrl; }
    set setPrevioustPage(url: string) {
        this.previousUrl = url;
    }

    // Api baseUrl
    private baseUrl: string = environment.apiPath;
    get apiPath() { return this.baseUrl; }

    public closeAllDialoges() {
        this._dialoge.closeAll();
    }

    constructor(private eventManager: EventManager, private _router: Router, private _dialoge: MatDialog) {
        this.eventManager.addGlobalEventListener('window', 'resize', this.onResize.bind(this));

        // Subscribing to router event
        this.currentUrl = this._router.url;
        this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            }
        });
    }

    // Emiting values for every resize event.
    private onResize(event: UIEvent) { this.windowResize.next(<Window>event.target); }

    // Load shared component
    public openModal(component, obj): MatDialogRef<any> {
        return this._dialoge.open(component,{ data: obj, disableClose: true })
    }

    // Handle XHR errors
    public handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('Client Error');
        } else {
            console.error('Server Error');
        }

        return throwError(error);
    };
}


// Action buttons
export interface ActionButtons {
    text?: string,
    title?: string,
    type: '-' | '-raised-' | '-icon-' | '-stroked-',
    icon?: string,
    color?: 'primary' | 'accent' | 'warn',
    action?()
}